  import "./App.css";
  import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
  import {
    useEffect,
    useState,
    useMemo,
    useCallback,
    useRef,
    lazy,
    Suspense,
  } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import { Toast } from "./helpers/alert";
  import { LangProvider } from "./context/langContext";
  import { logoutUser, session } from "./redux/apiCalls/loginCall";
  import UploadBill from "./pages/UploadBill/UploadBill";
  import AppLayout from "./layouts/AppLayout";
  import Loading from "./components/Loading/Loading";
  import Maximetro from "./pages/Mediciones/Maximetre/Maximetre";
  import UserActivity from "./pages/UserActivity/UserActivity";
  import ResetPassword from "./pages/ResetPassword/ResetPassword";
  import ForgotPassword from "./pages/ResetPassword/ForgotPassword";
  import Info from "./pages/Info/Info";
  import InfoRol from "./components/Info/InfoRol";
  import InfoOffice from "./components/Info/InfoOffice";
  import InfoAssignDevice from "./components/Info/InfoAssignDevice";
  import InfoMeasurement from "./components/Info/InfoMeasurement";
  import InfoInsights from "./components/Info/InfoInsights";
  import InfoCost from "./components/Info/InfoCost";
  import InfoReports from "./components/Info/InfoReports";
  import AlertsEvents from "./pages/EventsAlerts/AlertsEvents";
  import AlertsList from "./pages/Lists/AlertsList/AlertsList";
  import EditAlerts from "./pages/Alerts/EditAlerts";
  import AccessRestrictedModal from "./components/Modals/accessRestrictedModal";
  import ItemsBill from "./pages/Lists/ItemList/ItemsBill";
  import EditItemBill from "./components/EditItemBills/EditItemBill";
  import RegisterBill from "./pages/Register/RegisterBill";
  import Projects from "./pages/Projects/Projects";
  import ProjectDetail from "./pages/Projects/ProjectDetail";
  import HeatMap from "./pages/Analysis/HeatMap/Heatmap";
  import EnergyMatrix from "./pages/Analysis/EnergyMatrix/Energy_matrix";
  import PassiveLoad from "./pages/Analysis/PassiveLoad/PassiveLoad";
  import LoadDemanded from "./pages/Analysis/LoadDemand/Load_demand";
  import Reactive from "./pages/Analysis/Reactive";
  import {
    getCommunicationNotifications,
    getNotifications,
  } from "./redux/apiCalls/notifications/notificationsApiCalls";
  import { getAlldevices } from "./redux/apiCalls/devicesCall/devicesCall";
  import { socket } from "./requestMeth";
  import {
    addSuggestion,
    updateSuggestionUnread,
    upsertSuggestionFromSocket,
  } from "./redux/reducers/suggestions/suggestionsRedux";
  import {
    clearCommunicationNotifications,
    communicationNotificationsFailure,
    communicationNotificationsStart,
    communicationNotificationsSuccess,
  } from "./redux/reducers/communicationNotificationsRedux";
  import { addMesagges } from "./redux/reducers/mesagges/mesaggesRedux";
  import AiReports from "./pages/AiReports/AiReports";
  import { canAccessPlan, canViewPlan } from "./features/plan3d/access";

  const Login = lazy(() => import("./pages/Login/Login"));
  const PlanConfiguration = lazy(() => import("./features/plan3d/ConfigurationPage"));
  const PlanViewer = lazy(() => import("./features/plan3d/ViewerPage"));
  const CalculationModelEditor = lazy(() => import("./features/calculationModels/ModelEditorPage"));
  const ProjectCalculationModel = lazy(() => import("./features/calculationModels/ProjectCalculationModelPage"));
  const Register = lazy(() => import("./pages/Register/Register"));
  const Costos = lazy(() => import("./pages/Costos/Costos"));
  const Home = lazy(() => import("./pages/Home/Home"));
  const PowerSystemMonitoring = lazy(
    () => import("./pages/PowerSystemMonitoring/PowerSystemMonitoring"),
  );
  const User = lazy(() => import("./pages/User/User"));
  const EditUser = lazy(() => import("./components/EditUser/EditUser"));
  const InfoUser = lazy(() => import("./components/Modals/InfoUser"));
  const Lists = lazy(() => import("./pages/Lists/Lists"));
  const InfoCompany = lazy(() => import("./components/Modals/InfoCompany"));
  const EditCompany = lazy(() => import("./components/EditCompany/EditCompany"));
  const RegisterCompany = lazy(() => import("./pages/Register/RegisterCompany"));
  const InfoDevice = lazy(() => import("./components/Modals/InfoDevice"));
  const Reports = lazy(() => import("./pages/Reports/Reports"));
  const ProjectMonitoring = lazy(
    () => import("./pages/ProjectMonitoring/ProjectMonitoring"),
  );
  const RegisterDevice = lazy(() => import("./pages/Register/RegisterDevice"));
  const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
  const Confort = lazy(() => import("./pages/Mediciones/Comfort/Comfort"));
  const PerDevice = lazy(() => import("./pages/Mediciones/PerDevice/PerDevice"));
  const Evolution = lazy(() => import("./pages/Mediciones/Evolution/Evolution"));
  const Consumption = lazy(
    () => import("./pages/Mediciones/Consumption/Consumption"),
  );
  const UpdatePassword = lazy(
    () => import("./pages/UpdatePassword/UpdatePassword"),
  );
  const ConfigPassword = lazy(
    () => import("./pages/UpdatePassword/ConfigPassword"),
  );
  const RegisterEnergyMeter = lazy(() => import("./pages/Register/EnergyMeters"));
  const EbmLists = lazy(() => import("./pages/Lists/EbmLists"));
  const EditSupplierOffice = lazy(
    () => import("./components/EditSupplierOffice/EditSupplierOffice"),
  );
  const EditSupplier = lazy(
    () => import("./components/EditSupplier/EditSupplier"),
  );
  const AssignSupplierOffice = lazy(
    () => import("./pages/AssignSupplier/AssignSupplierOffice"),
  );
  const EditOffice = lazy(() => import("./components/EditOffice/EditOffice"));
  const RegisterSupplier = lazy(
    () => import("./pages/Register/RegisterSupplier"),
  );
  const DetalleEquipo = lazy(() => import("./pages/Equipo/DetalleEquipo"));
  const RegisterEquipo = lazy(() => import("./pages/Register/RegisterEquipo"));
  const SuggestionsList = lazy(
    () => import("./components/Suggestions/Suggestions"),
  );
  const PostModal = lazy(() => import("./components/Suggestions/PostModal"));
  const AllDevice = lazy(() => import("./pages/Lists/MasterList/AllDevices"));
  const Device = lazy(() => import("./pages/Device/Device"));
  const NewAlerts = lazy(() => import("./pages/Alerts/NewAlerts"));
  const HomeEBM = lazy(() => import("./pages/Ebm/Home/HomeEBM"));
  const Insights = lazy(() => import("./pages/Insights/Insights"));
  const HealthSafety = lazy(() => import("./pages/HealthSafety/HealthSafety"));
  const News = lazy(() => import("./pages/News/News"));
  const AgentRecommendations = lazy(
    () => import("./pages/AgentRecommendations/AgentRecommendations"),
  );
  const AgentDocuments = lazy(
    () => import("./pages/AgentDocuments/AgentDocuments"),
  );
  const AgentRecommendationDetail = lazy(
    () => import("./pages/AgentRecommendations/AgentRecommendationDetail"),
  );
  const Audit = lazy(() => import("./pages/Audit/Audit"));
  const Recommendations = lazy(
    () => import("./pages/Recommendations/Recommendations"),
  );
  const RecommendationDetail = lazy(
    () => import("./pages/Recommendations/RecommendationDetail"),
  );

  const LoadingFallback = () => <Loading />;

  const PUBLIC_PATHS = [
    "/monitoreo-sistema-electrico",
    "/login",
    "/lost-password",
    "/reset-password",
    "/expired-password",
  ];

  function App() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const user = useSelector((state) => state.user);
    const devices = useSelector((state) => state.devices?.currentDevices || []);
    const [lastClickTime, setLastClickTime] = useState(Date.now());
    const [warningShown, setWarningShown] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [restrictedReturnPath, setRestrictedReturnPath] = useState(null);
    const [globalUnreadAlerts, setGlobalUnreadAlerts] = useState([]);

    const prevTokenRef = useRef(null);
    const prevUnreadAlertIdsRef = useRef([]);
    const socketRef = useRef(socket);
    const alertsOwnerRef = useRef(null);
    const joinedUserIdRef = useRef(null);
    const joinedSuggestionsUserRef = useRef(null);
    const fetchingNotificationsRef = useRef(false);
    const notificationsRequestIdRef = useRef(0);
    const fetchingCommunicationNotificationsRef = useRef(false);
    const communicationNotificationsRequestIdRef = useRef(0);

    const suggestionsPath = "/admin/suggestions";

    const demoPath = [
      "/health-safety",
      "/info",
      "/info/informes",
      "/info/roles",
      "/info/gestion-plantas",
      "/info/equipos",
      "/info/mediciones",
      "/info/consumos-costos",
      "/analysis/reactive",
      "/master/agent-documents",
      "/master/agent-recommendations",
      "/power-system-monitoring",
    ];

    const basicoPath = [
      ...demoPath,
      "/consumption",
      "/evolution",
      "/confort",
      "/maximetro",
      "/PerDevice",
      "/analysis/reactive",
      "/analysis/heatmap",
      "/analysis/demandedLoaded",
      "/ebm/billsData",
      "/reports",
      "/master/agent-documents",
      "/master/agent-recommendations",
      "/recommendations",
      "/improvement-projects",
      "/power-system-monitoring",
      "/",
    ];

    const demoEbmPath = [
      ...demoPath,
      "/ebm/billsData",
      "/reports",
      "/power-system-monitoring",
    ];

    const restrictedFallbackPath =
      user.currentUser?.access_to === "BASICO"
        ? basicoPath[0]
        : user.currentUser?.access_to === "DEMOEBM"
          ? demoEbmPath[0]
          : demoPath[0];

    const isPublicPath = (path) => {
      const normalized = normalizePath(path);
      return PUBLIC_PATHS.some((publicPath) => {
        const normalizedPublicPath = normalizePath(publicPath);
        return normalized === normalizedPublicPath
          || normalized.startsWith(`${normalizedPublicPath}/`);
      });
    };

    const normalizePath = (s) =>
      (s || "").replace(/\/+$/, "").toLowerCase() || "/";

    const isSuggestionsPath = (path) =>
      normalizePath(path) === normalizePath(suggestionsPath);

    const isMasterPlanPath = (path) =>
      (canAccessPlan(user.currentUser) && normalizePath(path) === '/master/plan-configuration') ||
      (canViewPlan(user.currentUser) && normalizePath(path) === '/plan-3d');

    const isAllowedForDemo = (path) => {
      if (isMasterPlanPath(path)) return true;
      const p = normalizePath(path);
      if (isSuggestionsPath(p)) return true;
      return demoPath.some((base) => {
        const b = normalizePath(base);
        return p === b || p.startsWith(`${b}/`);
      });
    };

    const isAllowedForBasico = (path) => {
      if (isMasterPlanPath(path)) return true;
      const p = normalizePath(path);
      if (isSuggestionsPath(p)) return true;
      return basicoPath.some((base) => {
        const b = normalizePath(base);
        return p === b || p.startsWith(`${b}/`);
      });
    };

    const isAllowedForDemoEbm = (path) => {
      if (isMasterPlanPath(path)) return true;
      const p = normalizePath(path);
      if (isSuggestionsPath(p)) return true;
      return demoEbmPath.some((base) => {
        const b = normalizePath(base);
        return p === b || p.startsWith(`${b}/`);
      });
    };

    const validRestrictedReturnPath =
      restrictedReturnPath &&
      (restrictedReturnPath === `/user/${user.currentUser?.id_user}` ||
        (user.currentUser?.access_to === "DEMO"
          ? isAllowedForDemo(restrictedReturnPath)
          : user.currentUser?.access_to === "BASICO"
            ? isAllowedForBasico(restrictedReturnPath)
            : user.currentUser?.access_to === "DEMOEBM"
              ? isAllowedForDemoEbm(restrictedReturnPath)
              : true))
        ? restrictedReturnPath
        : null;

    const currentPrivilege = String(user.currentUser?.privilege || "").toLowerCase();

    const { adminOrMaster, master, masterOrEditor, viewer } = useMemo(() => {
      return {
        adminOrMaster: ["admin", "master", "admin-master"].includes(
          currentPrivilege,
        ),
        master: currentPrivilege === "master",
        masterOrEditor: ["editor", "master"].includes(currentPrivilege),
        viewer: currentPrivilege === "viewer",
      };
    }, [currentPrivilege]);

    const canAccessAgentRecommendations = [
      "viewer",
      "technical",
      "admin",
      "master",
      "admin-master",
    ].includes(currentPrivilege);

    const assignedDeviceIds = useMemo(
      () =>
        Array.from(
          new Set(
            (devices || [])
              .map((d) => Number(d?.id))
              .filter((n) => Number.isFinite(n)),
          ),
        ),
      [devices],
    );

    const assignedDeviceIdsKey = useMemo(
      () => assignedDeviceIds.join(","),
      [assignedDeviceIds],
    );

    useEffect(() => {
      const currentPath = location.pathname;

      const isDemoOnly =
        !!user.currentUser?.accessToken && user.currentUser?.access_to === "DEMO";

      const isBasico =
        !!user.currentUser?.accessToken &&
        user.currentUser?.access_to === "BASICO";

      const isDemoEbm =
        !!user.currentUser?.accessToken &&
        user.currentUser?.access_to === "DEMOEBM";
      
      const isOwnProfile = currentPath === `/user/${user.currentUser?.id_user}`;

      const isAllowedDemo = isAllowedForDemo(currentPath);
      const isAllowedBasicoRoute = isAllowedForBasico(currentPath);
      const isAllowedDemoEbmRoute = isAllowedForDemoEbm(currentPath);

      if (
        (isDemoOnly &&
          !isPublicPath(currentPath) &&
          !isOwnProfile &&
          !isAllowedDemo) ||
        (isBasico &&
          !isPublicPath(currentPath) &&
          !isOwnProfile &&
          !isAllowedBasicoRoute) ||
        (isDemoEbm &&
          !isPublicPath(currentPath) &&
          !isOwnProfile &&
          !isAllowedDemoEbmRoute)
      ) {
        setShowModal(true);
      } else {
        setShowModal(false);

        if (user.currentUser?.accessToken && !isPublicPath(currentPath)) {
          setRestrictedReturnPath(currentPath);
        }
      }
    }, [
      location.pathname,
      user.currentUser?.accessToken,
      user.currentUser?.access_to,
      user.currentUser?.id_user,
    ]);

    useEffect(() => {
      if (isPublicPath(location.pathname)) return;

      const validateTokenOnLoad = () => {
        const currentTime = Math.floor(Date.now() / 1000);
        const tokenExpiration = user.currentUser?.exp;

        if (!user.currentUser?.accessToken || currentTime >= tokenExpiration) {
          Toast.fire({
            icon: "info",
            title: "Su sesión ha expirado. Por favor, inicie sesión nuevamente.",
          });
          logoutUser(dispatch);
          navigate("/login");
        }
      };

      validateTokenOnLoad();
    }, [user.currentUser, dispatch, navigate, location.pathname]);

    const handleClick = useCallback(() => {
      if (!user?.currentUser?.accessToken) return;

      const currentTimeT = Date.now();
      const timeDifference = currentTimeT - lastClickTime;

      if (timeDifference > 5000) {
        setLastClickTime(currentTimeT);
        setWarningShown(false);
      }
    }, [lastClickTime, user?.currentUser?.accessToken]);

    useEffect(() => {
      const prevToken = prevTokenRef.current;
      const currentToken = user?.currentUser?.accessToken;

      if (!prevToken && currentToken) {
        setLastClickTime(Date.now());
        setWarningShown(false);
      }

      if (prevToken && !currentToken) {
        setLastClickTime(Date.now());
        setWarningShown(false);
      }

      prevTokenRef.current = currentToken;
    }, [user?.currentUser?.accessToken]);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;

      const handleKeyOrClick = (event) => {
        if (
          event.type === "click" ||
          event.key === "Tab" ||
          event.key === "Enter" ||
          (event.key >= "0" && event.key <= "9") ||
          event?.code?.includes("Numpad")
        ) {
          handleClick();
        }
      };

      document.addEventListener("click", handleKeyOrClick);
      document.addEventListener("keydown", handleKeyOrClick);

      return () => {
        document.removeEventListener("click", handleKeyOrClick);
        document.removeEventListener("keydown", handleKeyOrClick);
      };
    }, [handleClick, user?.currentUser?.accessToken]);

    useEffect(() => {
      if (
        !user?.currentUser?.accessToken ||
        !user?.currentUser?.exp ||
        isPublicPath(location.pathname)
      ) {
        return;
      }

      const interval = setInterval(() => {
        if (!user?.currentUser?.accessToken || !user?.currentUser?.exp) {
          clearInterval(interval);
          return;
        }

        const currentTime = Math.floor(Date.now() / 1000);
        const rest = user.currentUser?.exp - currentTime;
        const timeDifference = Date.now() - lastClickTime;

        if (timeDifference >= 9 * 60 * 1000 && !warningShown) {
          setWarningShown(true);
          Toast.fire({
            icon: "warning",
            showConfirmButton: true,
            position:
              user?.currentUser?.privilege === "editor" ? "center" : "top-end",
            timer: 10000,
            title:
              "Su sesión finalizará en breve por falta de actividad. De clic a este mensaje si quiere mantenerse logueado.",
          });
        }

        if (rest <= 0 || timeDifference >= 10 * 60 * 1000) {
          Toast.fire({
            icon: "info",
            timer: 5000,
            title:
              "Por razones de seguridad, su sesión ha sido cerrada. Por favor inicie sesión.",
          });

          logoutUser(dispatch, user.currentUser?.accessToken, {
            user: user.currentUser?.user,
          });
          navigate("/login");
          setWarningShown(false);
        } else if (rest < 2 * 60 && rest > 1) {
          session(dispatch, user, user.currentUser?.accessToken);
        }
      }, 6000);

      return () => clearInterval(interval);
    }, [
      lastClickTime,
      user?.currentUser?.accessToken,
      user?.currentUser?.exp,
      dispatch,
      navigate,
      warningShown,
      location.pathname,
    ]);

    useEffect(() => {
      if (isPublicPath(location.pathname)) return;

      if (!user.currentUser?.accessToken && !user.currentUser) {
        navigate("/login");
      } else if (user.currentUser?.passwordExpired === true) {
        navigate("/expired-password");
      }
    }, [user.currentUser, navigate, location.pathname]);

    useEffect(() => {
      const handleError = () => {
        Toast.fire({
          icon: "info",
          title: "Ocurrió un error. Por favor, recargue la página.",
          timer: 3000,
        });
      };

      window?.addEventListener("error", handleError);
      window?.addEventListener("unhandledrejection", handleError);

      return () => {
        window?.removeEventListener("error", handleError);
        window?.removeEventListener("unhandledrejection", handleError);
      };
    }, []);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;
      if (isPublicPath(location.pathname)) return;

      getAlldevices(dispatch, user.currentUser.accessToken);
    }, [dispatch, user?.currentUser?.accessToken, location.pathname]);

    const fetchNotificationsData = useCallback(async () => {
      if (!user?.currentUser?.accessToken) {
        setGlobalUnreadAlerts([]);
        prevUnreadAlertIdsRef.current = [];
        return;
      }

      if (isPublicPath(location.pathname)) return;
      if (fetchingNotificationsRef.current) return;

      const requestId = ++notificationsRequestIdRef.current;
      fetchingNotificationsRef.current = true;

      try {
        const filters = {
          include: ["count", "items"],
          // Temporarily hide AI recommendations from the global bell.
          sources: assignedDeviceIds.length > 0
            ? ["event", "report", "automatic_report"]
            : ["report", "automatic_report"],
          page: 1,
          limit: 100,
          device_ids: assignedDeviceIds,
        };

        const data = await getNotifications(
          dispatch,
          user.currentUser.accessToken,
          filters,
        );

        if (requestId !== notificationsRequestIdRef.current) {
          return;
        }

        if (!data || !Array.isArray(data.items)) {
          console.warn("Notifications sin items válidos:", data);
          return;
        }

        const unreadItems = data.items.filter((item) => !item?.is_read);
        setGlobalUnreadAlerts(unreadItems);

        const currentUnreadIds = unreadItems
          .map((item) => `${item.source}-${item.source_id}`)
          .filter(Boolean)
          .sort();

        const prevUnreadIds = prevUnreadAlertIdsRef.current;

        const hasNewUnread =
          prevUnreadIds.length > 0 &&
          currentUnreadIds.some((id) => !prevUnreadIds.includes(id));

        if (hasNewUnread) {
          Toast.fire({
            icon: "info",
            title: "Tienes una nueva notificación",
            timer: 4000,
          });
        }

        prevUnreadAlertIdsRef.current = currentUnreadIds;
      } catch (error) {
        if (requestId === notificationsRequestIdRef.current) {
          console.error("Error obteniendo notificaciones:", error);
        }
      } finally {
        if (requestId === notificationsRequestIdRef.current) {
          fetchingNotificationsRef.current = false;
        }
      }
    }, [
      dispatch,
      user?.currentUser?.accessToken,
      location.pathname,
      assignedDeviceIdsKey,
      assignedDeviceIds,
    ]);

    const fetchCommunicationNotificationsData = useCallback(async () => {
      if (!user?.currentUser?.accessToken) {
        dispatch(clearCommunicationNotifications());
        return;
      }

      if (isPublicPath(location.pathname)) return;
      if (fetchingCommunicationNotificationsRef.current) return;

      const requestId = ++communicationNotificationsRequestIdRef.current;
      fetchingCommunicationNotificationsRef.current = true;
      dispatch(communicationNotificationsStart());

      try {
        const data = await getCommunicationNotifications(
          user.currentUser.accessToken,
          {
            include: ["count", "items"],
            page: 1,
            limit: 1000,
          },
        );

        if (requestId !== communicationNotificationsRequestIdRef.current) {
          return;
        }

        dispatch(communicationNotificationsSuccess(data));
      } catch (error) {
        if (requestId === communicationNotificationsRequestIdRef.current) {
          console.error("Error obteniendo comunicaciones:", error);
          dispatch(
            communicationNotificationsFailure(
              error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "No se pudieron cargar las comunicaciones.",
            ),
          );
        }
      } finally {
        if (requestId === communicationNotificationsRequestIdRef.current) {
          fetchingCommunicationNotificationsRef.current = false;
        }
      }
    }, [
      dispatch,
      user?.currentUser?.accessToken,
      location.pathname,
    ]);

    useEffect(() => {
      const currentUserId = user?.currentUser?.id_user ?? null;

      if (alertsOwnerRef.current !== currentUserId) {
        setGlobalUnreadAlerts([]);
        prevUnreadAlertIdsRef.current = [];
        joinedUserIdRef.current = null;
        joinedSuggestionsUserRef.current = null;
        alertsOwnerRef.current = currentUserId;
        notificationsRequestIdRef.current = 0;
        fetchingNotificationsRef.current = false;
        communicationNotificationsRequestIdRef.current = 0;
        fetchingCommunicationNotificationsRef.current = false;
      }
    }, [user?.currentUser?.id_user]);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;
      if (!user?.currentUser?.id_user) return;
      if (isPublicPath(location.pathname)) return;

      fetchNotificationsData();
    }, [
      user?.currentUser?.accessToken,
      user?.currentUser?.id_user,
      assignedDeviceIdsKey,
      location.pathname,
      fetchNotificationsData,
    ]);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;
      if (isPublicPath(location.pathname)) return;

      fetchCommunicationNotificationsData();
    }, [
      user?.currentUser?.accessToken,
      user?.currentUser?.id_user,
      location.pathname,
      fetchCommunicationNotificationsData,
    ]);

    useEffect(() => {
      const socketInstance = socketRef.current;

      const handleSocketConnectLog = () => {
        console.log("🔌 socket conectado:", socketInstance.id);
      };

      const handleSocketDisconnectLog = (reason) => {
        console.log("❌ socket desconectado:", reason);
      };

      socketInstance.off("connect", handleSocketConnectLog);
      socketInstance.off("disconnect", handleSocketDisconnectLog);

      socketInstance.on("connect", handleSocketConnectLog);
      socketInstance.on("disconnect", handleSocketDisconnectLog);

      return () => {
        socketInstance.off("connect", handleSocketConnectLog);
        socketInstance.off("disconnect", handleSocketDisconnectLog);
      };
    }, []);

    useEffect(() => {
      const socketInstance = socketRef.current;
      const hasSession =
        !!user?.currentUser?.accessToken && !isPublicPath(location.pathname);

      if (hasSession) {
        if (!socketInstance.connected) {
          console.log("🟢 reconectando socket...");
          socketInstance.connect();
        }
      } else {
        joinedUserIdRef.current = null;
        joinedSuggestionsUserRef.current = null;
        prevUnreadAlertIdsRef.current = [];
        setGlobalUnreadAlerts([]);
        alertsOwnerRef.current = null;
        notificationsRequestIdRef.current = 0;
        fetchingNotificationsRef.current = false;
        communicationNotificationsRequestIdRef.current = 0;
        fetchingCommunicationNotificationsRef.current = false;
        dispatch(clearCommunicationNotifications());

        if (socketInstance.connected) {
          console.log("🔴 cerrando socket por logout o ruta pública...");
          socketInstance.disconnect();
        }
      }
    }, [user?.currentUser?.accessToken, location.pathname]);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;
      if (!user?.currentUser?.id_user) return;
      if (isPublicPath(location.pathname)) return;

      const socketInstance = socketRef.current;
      const currentUserId = Number(user.currentUser.id_user);

      const joinNotificationsRoom = () => {
        if (!socketInstance.connected) return;
        if (joinedUserIdRef.current === currentUserId) return;

        socketInstance.emit(
          "notifications:join",
          {
            userId: currentUserId,
            token: user.currentUser.accessToken,
          },
          (response) => {
            if (response?.ok) {
              joinedUserIdRef.current = currentUserId;
            } else {
              console.log("⛔ join notifications failed:", response);
            }
          },
        );
      };

      const handleConnect = () => {
        joinedUserIdRef.current = null;
        joinNotificationsRoom();
      };

      const handleNotificationsUpdated = async () => {
        await fetchNotificationsData();
        await fetchCommunicationNotificationsData();
      };

      socketInstance.off("connect", handleConnect);
      socketInstance.off("notifications:updated", handleNotificationsUpdated);

      socketInstance.on("connect", handleConnect);
      socketInstance.on("notifications:updated", handleNotificationsUpdated);

      if (!socketInstance.connected) {
        socketInstance.connect();
      } else {
        joinNotificationsRoom();
      }

      return () => {
        socketInstance.off("connect", handleConnect);
        socketInstance.off("notifications:updated", handleNotificationsUpdated);
      };
    }, [
      user?.currentUser?.accessToken,
      user?.currentUser?.id_user,
      location.pathname,
      fetchNotificationsData,
      fetchCommunicationNotificationsData,
    ]);

    useEffect(() => {
      if (!user?.currentUser?.accessToken) return;
      if (isPublicPath(location.pathname)) return;

      const socketInstance = socketRef.current;
      const mail = user?.currentUser?.mail?.trim();
      const username = user?.currentUser?.user?.trim();

      const identities = [mail, username].filter(
        (value, index, arr) => value && arr.indexOf(value) === index,
      );

      if (identities.length === 0) return;

      const joinSuggestionsRooms = () => {
        if (!socketInstance.connected) return;

        identities.forEach((identity) => {
          socketInstance.emit("auth:user", { username: identity }, (response) => {
            if (response?.ok) {
              console.log(`✅ joined suggestions room for ${identity}`);
            } else {
              console.log(
                `⛔ join suggestions failed for ${identity}:`,
                response,
              );
            }
          });
        });
      };

      const handleConnect = () => {
        joinSuggestionsRooms();
      };

      const handleConversationCreated = (payload) => {
        const suggestion = payload?.suggestion;
        const message = payload?.message;

        if (!suggestion) return;

        const isReceiver =
          suggestion?.receiver === mail || suggestion?.receiver === username;
        const isSender =
          suggestion?.user === mail || suggestion?.user === username;

        dispatch(
          addSuggestion({
            ...suggestion,
            messages: message ? [message] : [],
            mesagges: message ? [message] : [],
            last_message: message || null,
            unread_count: isReceiver && !isSender ? 1 : 0,
          }),
        );
      };

      const handleConversationUpdated = (payload) => {
        const suggestion = payload?.suggestion;
        const message = payload?.message;

        if (!suggestion) return;

        const isOwnMessage = message?.user === mail || message?.user === username;

        dispatch(
          upsertSuggestionFromSocket({
            ...suggestion,
            last_message: message || null,
          }),
        );

        dispatch(
          updateSuggestionUnread({
            suggestionId: suggestion.id,
            unread_count: isOwnMessage ? 0 : undefined,
            incrementUnread: !isOwnMessage,
            last_message: message || null,
          }),
        );
      };

      const handleMessageNew = (payload) => {
        const message = payload?.message;
        const suggestion = payload?.suggestion;

        if (!message || !suggestion?.id) return;

        dispatch(addMesagges(message));

        const isOwnMessage = message?.user === mail || message?.user === username;

        dispatch(
          upsertSuggestionFromSocket({
            ...suggestion,
            last_message: message,
          }),
        );

        dispatch(
          updateSuggestionUnread({
            suggestionId: suggestion.id,
            unread_count: isOwnMessage ? 0 : undefined,
            incrementUnread: !isOwnMessage,
            last_message: message,
          }),
        );
      };

      const handleConversationRead = (payload) => {
        dispatch(
          updateSuggestionUnread({
            suggestionId: payload?.suggestionId,
            unread_count: 0,
            read_at: new Date().toISOString(),
            last_read_message_id: payload?.last_read_message_id || null,
          }),
        );
      };

      socketInstance.off("connect", handleConnect);
      socketInstance.off(
        "suggestions:conversation:created",
        handleConversationCreated,
      );
      socketInstance.off(
        "suggestions:conversation:updated",
        handleConversationUpdated,
      );
      socketInstance.off("suggestions:message:new", handleMessageNew);
      socketInstance.off("suggestions:conversation:read", handleConversationRead);

      socketInstance.on("connect", handleConnect);
      socketInstance.on(
        "suggestions:conversation:created",
        handleConversationCreated,
      );
      socketInstance.on(
        "suggestions:conversation:updated",
        handleConversationUpdated,
      );
      socketInstance.on("suggestions:message:new", handleMessageNew);
      socketInstance.on("suggestions:conversation:read", handleConversationRead);

      if (!socketInstance.connected) {
        socketInstance.connect();
      } else {
        joinSuggestionsRooms();
      }

      return () => {
        socketInstance.off("connect", handleConnect);
        socketInstance.off(
          "suggestions:conversation:created",
          handleConversationCreated,
        );
        socketInstance.off(
          "suggestions:conversation:updated",
          handleConversationUpdated,
        );
        socketInstance.off("suggestions:message:new", handleMessageNew);
        socketInstance.off(
          "suggestions:conversation:read",
          handleConversationRead,
        );
      };
    }, [
      dispatch,
      user?.currentUser?.accessToken,
      user?.currentUser?.mail,
      user?.currentUser?.user,
      location.pathname,
    ]);

    return (
      <LangProvider>
        <AccessRestrictedModal
          show={showModal}
          onHide={() => setShowModal(false)}
          returnPath={validRestrictedReturnPath}
          fallbackPath={restrictedFallbackPath}
        />

        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/expired-password" element={<UpdatePassword />} />
            <Route path="/lost-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/monitoreo-sistema-electrico"
              element={<PowerSystemMonitoring accessMode="public" />}
            />

            <Route element={<AppLayout />}>
              <Route path="/" element={<Home />} />
              <Route
                path="/power-system-monitoring"
                element={<PowerSystemMonitoring />}
              />
              <Route path="/user/:id" element={<User />} />
              <Route path="/consumption" element={<Consumption />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/admin/suggestions" element={<SuggestionsList />} />
              <Route path="/suggestions" element={<PostModal />} />

              {!viewer && (
                <>
                  <Route path="/devices" element={<AllDevice />} />
                  <Route path="/devices/:id" element={<Device />} />
                  <Route path="/new-alert" element={<NewAlerts />} />
                  <Route path="/alerts-events" element={<AlertsEvents />} />
                  <Route path="/list-alerts" element={<AlertsList />} />
                  <Route path="/alerts/:id" element={<EditAlerts />} />
                  <Route
                    path="/devices/create/:id"
                    element={<RegisterDevice />}
                  />
                  <Route path="/ebm/uploadBill" element={<UploadBill />} />
                  <Route path="/analysis/heatmap" element={<HeatMap />} />
                  <Route
                    path="/analysis/energy-matrix"
                    element={<EnergyMatrix />}
                  />
                  <Route
                    path="/analysis/passive-load"
                    element={<PassiveLoad />}
                  />
                  <Route
                    path="/analysis/demandedLoaded"
                    element={<LoadDemanded />}
                  />
                </>
              )}

              <Route path="/insights" element={<AiReports />} />
              <Route path="/PerDevice" element={<PerDevice />} />
              <Route path="/confort" element={<Confort />} />
              <Route path="/evolution" element={<Evolution />} />
              <Route path="/maximetro" element={<Maximetro />} />
              <Route path="/analysis/reactive" element={<Reactive />} />
              <Route path="/project-monitoring" element={<ProjectMonitoring />} />
              <Route path="/health-safety" element={<HealthSafety />} />
              <Route path="/news" element={<News />} />
              <Route path="/ebm/billsData" element={<HomeEBM />} />


              <Route path="/info" element={<Info />} />
              <Route path="/info/roles" element={<InfoRol />} />
              <Route path="/info/gestion-plantas" element={<InfoOffice />} />
              <Route path="/info/equipos" element={<InfoAssignDevice />} />
              <Route path="/info/mediciones" element={<InfoMeasurement />} />
              <Route path="/info/informes" element={<InfoInsights />} />
              <Route path="/info/consumos-costos" element={<InfoCost />} />
              <Route path="/info/reportes" element={<InfoReports />} />
              <Route path="/improvement-projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/projects/:projectId/calculation-model" element={<ProjectCalculationModel />} />
              <Route path="/calculation-models/:modelId/versions/:versionId" element={<CalculationModelEditor />} />
              {canAccessAgentRecommendations && (
                <>
                  <Route
                    path="/master/agent-recommendations"
                    element={<AgentRecommendations />}
                  />
                  <Route
                    path="/master/agent-recommendations/:id"
                    element={<AgentRecommendationDetail />}
                  />
                </>
              )}
              {!master && (
                <>
                  <Route path="/recommendations" element={<Recommendations />} />
                  <Route path="/recommendations/:id" element={<RecommendationDetail />} />
                </>
              )}

              {adminOrMaster && (
                <>
                  <Route path="/costs" element={<Costos />} />
                  <Route path="/admin/lists" element={<Lists />} />
                  <Route path="/admin/users/register" element={<Register />} />
                  <Route path="/admin/users/edit/:id" element={<EditUser />} />
                  <Route path="/admin/users/:id" element={<InfoUser />} />
                  <Route path="/master/company/:id" element={<InfoCompany />} />
                  <Route
                    path="/master/company/edit/:id"
                    element={<EditCompany />}
                  />
                  <Route
                    path="/master/company/register"
                    element={<RegisterCompany />}
                  />
                  <Route path="/admin/devices/:id" element={<InfoDevice />} />
                  <Route path="/users/activity" element={<UserActivity />} />
                </>
              )}

              <Route path="/plan-3d" element={canViewPlan(user.currentUser) ? <PlanViewer /> : <NotFound />} />
              {master && (
                <>
                  <Route path="/master/plan-configuration" element={canAccessPlan(user.currentUser) ? <PlanConfiguration /> : <NotFound />} />
                  <Route
                    path="/admin/users/config"
                    element={<ConfigPassword />}
                  />
                  <Route path="/master/equipo/:id" element={<DetalleEquipo />} />
                  <Route
                    path="/master/equipo/register"
                    element={<RegisterEquipo />}
                  />
                  <Route
                    path="/admin/energy-meters/register"
                    element={<RegisterEnergyMeter />}
                  />
                  <Route path="/itemBill/register" element={<RegisterBill />} />
                  <Route path="/ebm/itemBill" element={<ItemsBill />} />
                  <Route path="/itemBill/edit/:id" element={<EditItemBill />} />
                  <Route
                    path="/master/agent-documents"
                    element={<AgentDocuments />}
                  />
                  <Route path="/master/audit" element={<Audit />} />
                </>
              )}

              {masterOrEditor && (
                <>
                  <Route path="/ebm/suppliers" element={<EbmLists />} />
                  <Route path="/ebm/office/:id" element={<EditOffice />} />
                  <Route path="/supplier/:id" element={<EditSupplier />} />
                  <Route
                    path="/supplier/register"
                    element={<RegisterSupplier />}
                  />
                  <Route
                    path="/supplieroffice/assign/:idcompany"
                    element={<AssignSupplierOffice />}
                  />
                  <Route
                    path="/supplierOffice/edit/:id"
                    element={<EditSupplierOffice />}
                  />
                </>
              )}

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </LangProvider>
    );
  }

  export default App;
